import {exeRequest} from '../utils/APIUtils'
import { LOCAL_STORAGE_KEYS } from '../constants';

export default {
 rechargeMomo : async (data) =>  {
    return (await exeRequest("/paiement/recharge-momo", "POST", data))
    
 }
}